import React, { useEffect } from 'react';
import { V2TextInput } from '@uhg-abyss/web/ui/TextInput';

export const Tin = () => {
  const MAX_LENGTH = 11;
  const MIN_LENGTH = 9;

  const isTinValid = (value) => {
    return (value.match(/\d/g) || []).length === 9;
  };

  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <V2TextInput
        label="TIN"
        model="searchDraft.tin"
        id="tin-textinput"
        aria-label="Type here to Enter a TIN "
        maxLength={MAX_LENGTH}
        required
        formatter={(value) => {
          return value.replace(
            /[!@#$%^&*)({}<>,.[\]+_`~=\\|';":/?A-Za-z]/g,
            ''
          );
        }}
        validators={{
          required: 'TIN is required.',
          validate: {
            isValidTin: (value) => {
              return (
                (value.length >= MIN_LENGTH &&
                  !value.includes('--') &&
                  !value.startsWith('-') &&
                  !value.endsWith('-') &&
                  isTinValid(value)) ||
                'TIN is invalid.'
              );
            },
            spaceInTin: (value) => {
              return value.includes(' ')
                ? 'TIN is invalid. Please remove spaces.'
                : true;
            },
          },
        }}
        isClearable
        autoComplete="off"
      />
    </React.Fragment>
  );
};

Tin.propTypes = {};

Tin.defaultProps = {};
